import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
//import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCHrq6n-pjT6iIecIObN93oi-LFgkSqjzg',
  authDomain: 'map-quiz-8a353.firebaseapp.com',
  projectId: 'map-quiz-8a353',
  storageBucket: 'map-quiz-8a353.appspot.com',
  databaseURL:
    'https://map-quiz-8a353-default-rtdb.europe-west1.firebasedatabase.app',
  messagingSenderId: '304849935488',
  appId: '1:304849935488:web:c65326305c5adafe3a1a65',
  measurementId: 'G-J1CR3NZEJ6',
};

const firebaseApp = initializeApp(firebaseConfig);
export const database = getDatabase(firebaseApp);
//export const database = getFirestore(firebaseApp);
export const auth = getAuth();
export const storage = getStorage();

auth.languageCode = 'nb';
